import React from 'react';
import './LoadingSkeleton.css'; // Import the CSS file

const LoadingSkeleton = ({itemCount = 1, ...props}) => {
  const skeletonItems = Array.from({ length: itemCount }, (_, index) => index);
  return (
    <div className={`loading-skeleton ${props.className}`} {...props}>
      {skeletonItems.map(index => (
        <div
          key={index}
          className="loading-skeleton-item"
          style={props.innerStyle}
        ></div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;